import { Action, createReducer, on } from '@ngrx/store';
import * as actions from './../actions/menu.actions';
import { IMenuState } from './../interfaces/menu';

const initialState: IMenuState = {
  menu: null,
  adminMenu: null
};

const menuReducer = createReducer(
  initialState,
  on(actions.GetMenuAction, state => ({
    ...state,
    menu: null
  })),
  on(actions.SetMenuAction, (state, payload) => ({
    ...state,
    menu: payload.menu
  })),
  on(actions.GetAdminMenuAction, state => ({
    ...state,
    adminMenu: null
  })),
  on(actions.SetAdminMenuAction, (state, payload) => ({
    ...state,
    adminMenu: payload.adminMenu
  }))
);

export function MenuReducer(state: IMenuState | undefined, action: Action) {
  return menuReducer(state, action);
}
